import { useQuery } from '@tanstack/react-query'

import { fetchWithHeaders } from 'utils'

import { GrapeAPIError, type GrapeAPIErrorType } from './GrapeAPIError'
import { type Employee } from '../../types'

export function useGetBrokersEmployees ({
  employerId,
  planYear
}: {
  employerId: string;
  planYear: number;
}) {
  return useQuery<{ data: { employees: Employee[] } }, GrapeAPIErrorType >({
    queryKey: [
      'employerId',
      employerId,
      'plan_year',
      planYear
    ],
    queryFn: async () => {
      const response = await fetchWithHeaders(`/api/brokers/employers/${employerId}/employees?plan_year=${planYear}`)
      if (!response.ok) {
        const errorJson = await response.json()
        throw GrapeAPIError({
          status: response.status,
          message: errorJson.message,
          errors: errorJson.errors,
        })
      }
      return response.json()
    },
    enabled: !!planYear
  })
}
